import moment from "moment";
import React from "react";
import { agentIdFor_dealerCode, coverType, typeOfCal } from "../Constant";
import { encrypt } from "../Constant/Encrypt";

export const Lifetime_req_obj = ({ userData, type, zone = "", agentData, CI_coverType, isInRestricedZone, intermediarySubCatCd = "" }) => {
  const default_covertype_for_CI = CI_coverType
  let coverType_data = coverType(
    parseInt(userData.adult),
    parseInt(userData.child),
    type,
    userData
  );

  let SI_VALUE = "5000000";
  let DEDUCTIBLE_VALUE = "500000";

  if (type === typeOfCal.prohealthPrime || type === typeOfCal.primeSenior) {
    SI_VALUE = "750000";
  }

  if ((type === typeOfCal.primeSenior || type === typeOfCal.superTopUp || type === typeOfCal.prohealthPrime || type === typeOfCal.mchiSarvah) && intermediarySubCatCd == "POSP") {
    SI_VALUE = "500000";
  }

  if (type === typeOfCal.superTopUp) {
    SI_VALUE = "500000";
  }

  if (type === typeOfCal.pa) {
    SI_VALUE = "750000";
  }

  let insurer_arr_adult = userData.adultData.map((ei) => {
    return {
      DOB: ei.dob,
      GENDER: ei.gender,
      Adult: "YES",
    };
  });
  const InsuredAge = moment().diff(
    moment(insurer_arr_adult[0]?.DOB, "DD/MM/YYYY").format(),
    "years",
    false
  )
  const isRestricedCriteria = ((userData.adult === 1 && InsuredAge >= 18 && InsuredAge <= 30 && userData.child === 0 && coverType_data === 'individual') || isInRestricedZone)
  if (type === typeOfCal.prohealth) {
    if ( ['325','148'].includes(agentData.channel) && isRestricedCriteria) {
      SI_VALUE = '750000'
    } else {
      SI_VALUE = "750000";
    }
    //SI_VALUE = "550000";
  }

  let insurer_arr_child = userData.childData.map((ei) => {
    return {
      DOB: ei.dob,
      GENDER: ei.gender,
      Adult: "NO",
    };
  });


  if (type === typeOfCal.ci || type === typeOfCal.accident_Shield || type === typeOfCal.mchiSarvah) {

    if (!coverType_data) {
      coverType_data = default_covertype_for_CI
    }

    insurer_arr_adult = userData.adultData.map((ei) => {
      const adultObj = {
        DOB: ei.dob,
        GENDER: ei.gender,
        Adult: "YES",
        AnnualIncome: ei.annualI,
        RelationShip: ei.relationship,
      };
      if (type === typeOfCal.ci || type === typeOfCal.accident_Shield) {
        adultObj.Cover = Number(ei.si) / 100000
      }
      return adultObj
    });

    insurer_arr_child = userData.childData.map((ei) => {
      const childObj = {
        DOB: ei.dob,
        GENDER: ei.gender,
        Adult: "NO",
        AnnualIncome: ei.annualI,
        RelationShip: ei.relationship,
      };
      if (type === typeOfCal.ci || type === typeOfCal.accident_Shield) {
        childObj.Cover = Number(ei.si) / 100000
      }
      return childObj
    });

  }

  if (type === typeOfCal.pa) {
    if (!coverType_data) {
      coverType_data = default_covertype_for_CI
    }
    insurer_arr_adult = userData.adultData.map((ei) => {
      return {
        DOB: ei.dob,
        GENDER: ei.gender,
        Adult: "YES",
        AnnualIncome: ei.annualI,
        RelationShip: ei.relationship,
        Cover: Number(ei.si) / 100000
      };
    });

    insurer_arr_child = userData.childData.map((ei) => {
      return {
        DOB: ei.dob,
        GENDER: ei.gender,
        Adult: "NO",
        AnnualIncome: ei.annualI,
        RelationShip: ei.relationship,
        Cover: Number(ei.si) / 100000
      };
    });

  }


  const obj = {
    preparedData: {
      All_Insured_Are_Resident_Indian: "YES",
      sumInsured2: SI_VALUE,
      coverTypeInfo: {
        adultCount: userData.adult,
        peopleCount: userData.adult + userData.child,
        childCount: userData.child,
        details: [...insurer_arr_adult, ...insurer_arr_child],
      },
      portability: (type === typeOfCal.lifetime ? userData?.isPort :  "NO") ?? "NO",
      parentagencyid: agentData.parentagencyid,
      coverType: coverType_data,
      paymentMode: "",
      emailAddress: userData.email,
      mobileNumber: userData.phn,
      sumInsured: SI_VALUE,
      zone: zone,
      pinCode: userData.pincode,
      tenure: "1",
      createDate: moment(Date.now()).format("YYYY-MM-DD"),
      channel: agentData.channel ?? "",
      agentId: agentData.agentId ?? "",
      agentName: agentData.agentName ?? "",
      agentMobileNum: agentData.mobileNo ?? "",
      agentEmailId: agentData.emailIId ?? "",
      branchId: agentData.branchId ?? "",
      employeeCodeOrSpCode: agentData.employeeCodeOrSPCode ?? "",
      employeeNameOrSpName: agentData.employeeNameOrSPName ?? "",
      parentagencyname: agentData.parentagencyname ?? "",
      mappedirdalocation: agentData.mappedirdalocation ?? "",
      businesscreditchannel: agentData.businesscreditchannel ?? "",
      pan: agentData.pan ?? "",
      flowType: agentData.flowType ?? "",
      authorization: agentData.authorization ?? "",
      businessFor: agentData.businessFor ?? "",
      intermediarySubCatCd: intermediarySubCatCd,
      skip: agentData.skip ?? "",
      refA: agentData.refA ?? "",
      refB: agentData.refB ?? "",
      refC: agentData.refC ?? "",
      applicationNum: agentData.applicationNum
    },
  };

  if (type === typeOfCal.accident_Shield && agentData.agentId == agentIdFor_dealerCode && agentData.dealerCode !== undefined && agentData.dealerCode != '' && agentData.channel == '375') {
    obj.preparedData.refC = agentData.dealerCode
  }

  if (type === typeOfCal.superTopUp) {
    obj.preparedData.deductible = DEDUCTIBLE_VALUE;
    obj.preparedData.paymentMode = "single"
  }
  if (type === typeOfCal.prohealth) {
    obj.preparedData.paymentMode = "single"
  }
  if (type === typeOfCal.pa) {
    obj.product = "Personal Accident"
    obj.product_code = "LTPRAC"
    obj.mode = "all"
  }
  if (type === typeOfCal.mchiSarvah) {
    obj.preparedData.isPort = userData?.isPort
    obj.preparedData.isCommercialDiscount = (agentData.channel == '148') ? 'NO' : userData?.isCommercialDiscount
    obj.preparedData.commercialDiscountRate = (agentData.channel == '148') ? 'SHMONDISC' : userData?.commercialDiscountRate
  }
  if (type === typeOfCal.lifetime) {
    obj.preparedData.isPort = userData?.isPort ?? "NO"
  }
  return encrypt(JSON.stringify(obj));
};

export const Critical_req_obj = ({ userData, type, zone = "", agentData, CI_coverType, intermediarySubCatCd = "" }) => {

  const default_covertype_for_CI = CI_coverType
  let coverType_data = coverType(
    parseInt(userData.adult),
    parseInt(userData.child),
    type
  );

  let SI_VALUE = "5000000";
  let DEDUCTIBLE_VALUE = "500000";

  if (type === typeOfCal.prohealthPrime || type === typeOfCal.primeSenior) {
    SI_VALUE = "750000";
  }

  if (type === typeOfCal.superTopUp) {
    SI_VALUE = "500000";
  }

  if (type === typeOfCal.prohealth) {
    SI_VALUE = "550000";
  }



  let insurer_arr_adult = userData.adultData.map((ei) => {
    return {
      DOB: ei.dob,
      GENDER: ei.gender,
      Adult: "YES",
    };
  });

  let insurer_arr_child = userData.childData.map((ei) => {
    return {
      DOB: ei.dob,
      GENDER: ei.gender,
      Adult: "NO",
    };
  });


  if (type === typeOfCal.ci) {

    if (!coverType_data) {
      coverType_data = default_covertype_for_CI
    }

    insurer_arr_adult = userData.adultData.map((ei) => {
      return {
        DOB: ei.dob,
        GENDER: ei.gender,
        Adult: "YES",
        AnnualIncome: ei.annualI,
        RelationShip: ei.relationship,
        Cover: Number(ei.si) / 100000
      };
    });

    insurer_arr_child = userData.childData.map((ei) => {
      return {
        DOB: ei.dob,
        GENDER: ei.gender,
        Adult: "NO",
        AnnualIncome: ei.annualI,
        RelationShip: ei.relationship,
        Cover: Number(ei.si) / 100000
      };
    });

  }


  const obj = {
    preparedData: {
      All_Insured_Are_Resident_Indian: "YES",
      sumInsured2: SI_VALUE,
      coverTypeInfo: {
        adultCount: userData.adult,
        peopleCount: userData.adult + userData.child,
        childCount: userData.child,
        details: [...insurer_arr_adult, ...insurer_arr_child],
      },
      portability: "NO",
      parentagencyid: agentData.parentagencyid,
      coverType: coverType_data,
      paymentMode: "",
      emailAddress: userData.email,
      mobileNumber: userData.phn,
      sumInsured: SI_VALUE,
      zone: zone,
      pinCode: userData.pincode,
      tenure: "1",
      createDate: moment(Date.now()).format("YYYY-MM-DD"),
      channel: agentData.channel ?? "",
      agentId: agentData.agentId ?? "",
      agentName: agentData.agentName ?? "",
      agentMobileNum: agentData.mobileNo ?? "",
      agentEmailId: agentData.emailIId ?? "",
      branchId: agentData.branchId ?? "",
      intermediarySubCatCd: intermediarySubCatCd,

      employeeCodeOrSpCode: agentData.employeeCodeOrSPCode ?? "",
      employeeNameOrSpName: agentData.employeeNameOrSPName ?? "",
      parentagencyname: agentData.parentagencyname ?? "",
      mappedirdalocation: agentData.mappedirdalocation ?? "",
      businesscreditchannel: agentData.businesscreditchannel ?? "",
      pan: agentData.pan ?? "",
      flowType: agentData.flowType ?? "",
      businessFor: agentData.businessFor ?? "",
      skip: agentData.skip ?? "",
      refA: agentData.refA ?? "",
      refB: agentData.refB ?? "",
      refC: agentData.refC ?? ""
    },
  };


  if (type === typeOfCal.superTopUp) {
    obj.preparedData.deductible = DEDUCTIBLE_VALUE;
    obj.preparedData.paymentMode = "single"
  }
  if (type === typeOfCal.prohealth) {
    obj.preparedData.paymentMode = "single"
  }
  if (type === typeOfCal.ci) {
    obj.product = "CI"
    obj.product_code = "SPLS03SBLF"
    // obj.leadId = "ba533a53-aac1-6510-0d83-d9ef6adcedc7"
    obj.mode = "all"
  }
  if (type === typeOfCal.accident_Shield) {
    obj.product = "ACCIDENT SHIELD"
    //obj.product_code = "ACCSHD"
    // obj.leadId = "ba533a53-aac1-6510-0d83-d9ef6adcedc7"
    obj.mode = "all"
  }
  return encrypt(JSON.stringify(obj));
};

